import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import PageHeroTitle from '../components/PageHeroTitle'
import RidingList from '../components/PointOfinterestType/RidingList'
import { usePois } from '../contexts/PoisContext'
import { setFlashMessage } from '../contexts/WebsiteContext'

const PoiTypeTrail = () => {
  const poiType = 'TRAIL'
  const pageName = `POI_TYPE_${poiType}`
  const { t } = useTranslation()
  const { pois } = usePois()

  const filteredPois = pois.filter((poi) => poi.poiType.name === poiType)

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t(`${pageName}_PAGE_TITLE`)}
        description={t(`${pageName}_PAGE_DESCRIPTION`)}
      />

      <div className="container section py-4">
        <p className="lead">{t(`${pageName}_PAGE_DETAILS`)}</p>

        {filteredPois.length > 0 && <RidingList pois={filteredPois} />}

        <div className="text-center mt-5">
          <img
            className="img-fluid rounded"
            src="/images/photos/95cc8f97-0f60-4275-a019-d2f30f928653.jpg"
            alt="Trail"
          />
          <p className="text-muted mt-2 fst-italic">
            Tourroc. Quelques pas de plus et le sentier devient balcon, le
            regard bascule alors vers l’infini.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default PoiTypeTrail
